import { HttpClient } from '@angular/common/http';
import { Injectable, inject, linkedSignal, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { map, switchMap } from 'rxjs';

import { SessionService } from '../../../services';
import { UserService } from '../../../user';

@Injectable({ providedIn: 'root' })
export class MenuService {
  private http = inject(HttpClient);
  private userService = inject(UserService);
  private sessionService = inject(SessionService);

  constructor() {
    this.userService.preferences
      .pipe(
        map((p) => p.mainMenuCollapsed === true),
        takeUntilDestroyed(),
      )
      .subscribe((v) => {
        this.mainMenuCollapsed.set(v);
      });
  }

  menu = toSignal(
    this.sessionService.selectedClientId.pipe(
      switchMap(() => this.http.get<string[]>('/api/v4/public/navigation/combined')),
    ),
  );

  mainMenuCollapsed = signal(false);
  active = signal<string | null>(null);

  lastUpdate = linkedSignal<string | null, { previous: string | null; now: string | null }>({
    source: this.active,
    computation: (source, previous) => ({
      previous: previous?.source ?? null,
      now: source,
    }),
    equal: (a, b) => a.previous === b.previous && a.now === b.now,
  });

  setInactive() {
    this.active.set(null);
  }

  async toggleMenu() {
    const newValue = !this.mainMenuCollapsed();
    this.userService.sendUpdate({ 'preferences.mainMenuCollapsed': newValue }, 'MenuToggle');
    this.mainMenuCollapsed.set(newValue);
  }
}
